import { FaEdit, FaTrash, FaChartBar, FaUserPlus, FaListUl, FaCheckCircle, FaAngleDown, FaUserCog, FaExchangeAlt, FaFileArchive } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; // IMPORTANT: Ajoutez cette ligne
import DeleteAccountButton from '../Shared/DeleteAccountButton';
import { canSubmitToValidation } from "../service/utils/accountUtils";
import { useSmartDropdown } from "../service/Hooks/useSmartDropdown";
import SecurityTransferModal from "../admin/Account/TransfertTitre/SecurityTransferModal";
import { useState } from "react";
import { VALIDATION_STATUS } from "../service/utils/validationStatus";

const AccountActionsDropdown = ({
  account,
  selectedDomain,
  handleOpenModalSecurities,
  handleShowEditAccountModal,
  handleDeleteSuccess,
  handleGenerateTitleReport,
  handleGenerateTransactionReport,
  openContactForm,
  openContactList,
  openModal,
  handleOpenModal,
  openAssociationForm,
  openAssociationList,
  handleOpenSubmitAccountConfirmation,
  handleOpenManagedAccounts,
  handleOpenHistoricsDocuments
}) => {
  const {
    isOpen,
    position,
    triggerRef,
    dropdownRef,
    toggleDropdown,
    closeDropdown
  } = useSmartDropdown();

  const handleAction = (callback) => {
    callback();
    closeDropdown();
  };
  
  const [showTransferModal, setShowTransferModal] = useState(false);

  const ALLOWED_EDIT_STATUSES = [VALIDATION_STATUS.DRAFT, VALIDATION_STATUS.REJECTED];
  
  return (
    <>
      <div className={`dropdown-actions  ${isOpen ? 'is-open' : ''}`}>
        {/* Overlay pour capturer les clics */}
        {isOpen && <div className="dropdown-overlay" />}
        
        {/* Bouton déclencheur */}
        <button 
          ref={triggerRef}
          className="action-icon" 
          onClick={toggleDropdown}
          data-tooltip-id="actions-tooltip"
          data-tooltip-content="Actions"
        >
          <FaAngleDown size={18} />
        </button>
        
        {/* Menu déroulant avec positionnement intelligent */}
        <div
          ref={dropdownRef}
          className="dropdown-menu-container"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            display: isOpen ? 'block' : 'none'
          }}
          hidden={!isOpen}
        >
          <div className="dropdown-menu-custom">
            {/* Édition du compte */}
            {!account.isManagedAccount && ALLOWED_EDIT_STATUSES.includes(account.validationStatus) ? (
              <button 
                className="dropdown-item-custom" 
                onClick={() => handleAction(() => handleShowEditAccountModal(account))}
              >
                <FaEdit size={14} className="me-2" /> Modifier
              </button>
            ) : (
              <div 
                className="dropdown-item-custom text-muted"
                data-tooltip-id={`edit-disabled-tooltip-${account.id}`}
                data-tooltip-content={
                  account.isManagedAccount 
                    ? "Les comptes administrés ne peuvent pas être modifiés" 
                    : "Seuls les comptes en brouillon ou rejetés peuvent être modifiés"
                }
                data-tooltip-place="top" // Force le positionnement en haut
                data-tooltip-variant="dark" // Style sombre
                style={{ cursor: 'not-allowed', opacity: 0.6 }}
              >
                <FaEdit size={14} className="me-2" /> Modifier
              </div>
            )}
            
            {/* Suppression du compte */}
            <button 
              className="dropdown-item-custom text-bg-danger text-danger" 
              onClick={() => closeDropdown()}
            >
              <FaTrash size={12} className="me-2" />
              <DeleteAccountButton 
                accountId={account.id} 
                accountTypeName={account.accountTypeName} 
                onDeleteSuccess={() => handleDeleteSuccess(account.id, account.accountTypeName)} 
              />
            </button>
            
            <div className="dropdown-divider"></div>
            
            {/* Rapports */}
            <button 
              className="dropdown-item-custom" 
              onClick={() => handleAction(() => handleGenerateTitleReport(account.id, selectedDomain.id))}
            >
              <FaChartBar size={14} className="me-2" /> Relevé de compte
            </button>
            
            <button
              className="dropdown-item-custom"
              onClick={() => handleAction(() => handleGenerateTransactionReport(account.id, selectedDomain.id))}
            >
              <FaChartBar size={14} className="me-2" /> Rapport transactions
            </button>

            {/* Option de transfert de titres */}
            <button 
              className="dropdown-item-custom" 
              onClick={() => {
                closeDropdown();
                setShowTransferModal(true);
              }}
            >
              <FaExchangeAlt size={14} className="me-2" />
              Transfert de titres
            </button>

            {/* Voir les documents d'historique */}
            {(account.validationStatus === VALIDATION_STATUS.VALIDATED) && (
              <button 
                className="dropdown-item-custom" 
                onClick={() => handleAction(() => handleOpenHistoricsDocuments(account))}
                data-tooltip-id={`historics-tooltip-${account.id}`}
                data-tooltip-content="Voir l'historique complet avec documents de preuve"
                data-tooltip-place="top"
              >
                <FaFileArchive size={14} className="me-2" />
                Historique complet
              </button>
            )}
            
            <div className="dropdown-divider"></div>
            
            {/* Contacts */}
            <button 
              className="dropdown-item-custom" 
              onClick={() => handleAction(() => openContactForm(account.id))}
            >
              <FaUserPlus size={14} className="me-2" /> Ajouter personne à contacter
            </button>
            
            <button 
              className="dropdown-item-custom" 
              onClick={() => handleAction(() => openContactList(account.id))}
            >
              <FaListUl size={14} className="me-2" /> Liste contacts
            </button>
            
            {/* Représentants légaux */}
            {['Entreprise', 'Banques', 'Assurance', 'Autres Entreprises','Particulier','Opcvm','Association','Opc', 'Fia'].includes(account.accountTypeName) && (
              <>
                <button 
                  className="dropdown-item-custom" 
                  onClick={() => handleAction(() => openModal(account.id))}
                >
                  <FaUserPlus size={14} className="me-2" /> Ajouter un représentant
                </button>
                
                <button 
                  className="dropdown-item-custom" 
                  onClick={() => handleAction(() => handleOpenModal(account.id))}
                >
                  <FaListUl size={14} className="me-2" /> Liste représentants légaux
                </button>
              </>
            )}

            {/* Voir les comptes administrés */}
            {!account.isManagedAccount && (
              <button 
                className="dropdown-item-custom" 
                onClick={() => handleAction(() => handleOpenManagedAccounts(account))}
                data-tooltip-id={`managed-accounts-tooltip-${account.id}`}
                data-tooltip-content="Voir les comptes que ce client administre"
                data-tooltip-place="top"
              >
                <FaUserCog size={14} className="me-2" /> Voir les comptes administrés
              </button>
            )}
            
            {/* Mandataires */}
            {['Association'].includes(account.accountTypeName) && (
              <>
                <button 
                  className="dropdown-item-custom" 
                  onClick={() => handleAction(() => openAssociationForm(account.id))}
                >
                  <FaUserPlus size={14} className="me-2" /> Ajouter un mandataire
                </button>
                
                <button 
                  className="dropdown-item-custom" 
                  onClick={() => handleAction(() => openAssociationList(account.id))}
                >
                  <FaListUl size={14} className="me-2" /> Liste des mandataires
                </button>
              </>
            )}

            <div className="dropdown-divider"></div>
            
            {/* Soumission à validation */}
            {canSubmitToValidation(account) && (
              <button
                className="dropdown-item-custom"
                onClick={() => handleAction(() => handleOpenSubmitAccountConfirmation(account))}
              >
                <FaCheckCircle className="me-2" />
                Soumettre à la validation
              </button>
            )}
          </div>
        </div>
      </div>

      {/* TOUS LES TOOLTIPS EN DEHORS DU DROPDOWN - au niveau racine */}
      <Tooltip 
        id="actions-tooltip" 
        place="top" 
        effect="solid"
        style={{ zIndex: 9999 }} // Haut niveau de z-index
      />
      
      {/* Tooltip pour bouton Modifier désactivé */}
      <Tooltip 
        id={`edit-disabled-tooltip-${account.id}`}
        place="top"
        style={{ 
          zIndex: 10000,
          maxWidth: '300px',
          fontSize: '12px',
          padding: '8px 12px',
          backgroundColor: '#333',
          color: '#fff',
          borderRadius: '4px'
        }}
      />
      
      {/* Tooltip pour historique */}
      <Tooltip 
        id={`historics-tooltip-${account.id}`}
        place="top"
        style={{ zIndex: 9999 }}
      />
      
      {/* Tooltip pour comptes administrés */}
      <Tooltip 
        id={`managed-accounts-tooltip-${account.id}`}
        place="top"
        style={{ zIndex: 9999 }}
      />

      {/* Modal de transfert */}
      <SecurityTransferModal
        show={showTransferModal}
        onHide={() => setShowTransferModal(false)}
        accountId={account.id}
        accountDisplayName={account.displayName || `${account.firstName} ${account.lastName}`.trim() || account.companyName}
        domainId={selectedDomain?.id}
        onSuccess={() => {
          handleOpenModalSecurities?.(account.id);
        }}
      />
    </>
  );
};

export default AccountActionsDropdown;